module.exports = __webpack_public_path__ + "static/omnichannel-1551bc52b14b9fadd39dc1d6d1127c70.svg";